import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Comet from "./Comet"; // Импортируем компонент Comet

const CircularProgressBar = ({ value }) => {
    const [animatedValue, setAnimatedValue] = useState(0);
    const gradientId = "gradientId";

    useEffect(() => {
        setAnimatedValue(value);
    }, [value]);

    return (
        <div style={{ width: "200px", height: "200px", position: "relative" }}>
            <svg style={{ height: 0 }}>
                <defs>
                    <linearGradient id={gradientId}>
                        <stop offset="0%" stopColor="rgba(255, 0, 0, 1)" />
                        <stop offset="50%" stopColor="rgba(255, 0, 255, 1)" />
                        <stop offset="100%" stopColor="rgba(0, 0, 255, 1)" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgressbar
                value={animatedValue}
                text={`${animatedValue}%`}
                styles={buildStyles({
                    pathColor: `url(#${gradientId})`,
                    textColor: "#0000ff",
                    trailColor: "#e0e0e0",
                })}
            />
            <Comet /> {/* Используем компонент Comet */}
        </div>
    );
};

export default CircularProgressBar;
